/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConnectResponse,
  DisconnectResponse,
  IncrementalReconnectResponse,
  IntegrationStatusListRequest,
  IntegrationStatusListResponse,
  IntegrationStatusResponse,
  MapString,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "google-authentication";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Initiates OAuth authorization flow to connect an account to Google
   *
   * @name ConnectAnAccountToGoogle
   * @request POST:/v2/tenant/{tenantId}/credential-ref/{credentialRef}/connect
   * @deprecated
   * @secure
   */
  connectAnAccountToGoogle = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/credential-ref/${credentialRef}/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectAnAccountToGoogle */
  connectAnAccountToGooglePathGetter = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/credential-ref/${credentialRef}/connect`, query);

  /**
   * @description Incremental OAuth authorization flow to reconnect an account to Google and grant missing scopes
   *
   * @name IncrementallyReconnectAnAccountToGoogle
   * @request POST:/v2/tenant/{tenantId}/credential-ref/{credentialRef}/incrementally-reconnect
   * @deprecated
   * @secure
   */
  incrementallyReconnectAnAccountToGoogle = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      IncrementalReconnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/credential-ref/${credentialRef}/incrementally-reconnect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for incrementallyReconnectAnAccountToGoogle */
  incrementallyReconnectAnAccountToGooglePathGetter = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/credential-ref/${credentialRef}/incrementally-reconnect`, query);

  /**
   * @description Disconnects an account from Google if is connected
   *
   * @name DisconnectAnAccountFromGoogle
   * @request POST:/v2/tenant/{tenantId}/credential-ref/{credentialRef}/disconnect
   * @secure
   */
  disconnectAnAccountFromGoogle = (tenantId: string, credentialRef: string, params: RequestParams = {}) =>
    this.request<
      DisconnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/credential-ref/${credentialRef}/disconnect`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnectAnAccountFromGoogle */
  disconnectAnAccountFromGooglePathGetter = (tenantId: string, credentialRef: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/credential-ref/${credentialRef}/disconnect`);

  /**
   * @description Disconnects a secondary calendar from Google if is connected
   *
   * @name DisconnectSecondaryCalendarFromGoogle
   * @request POST:/v2/tenant/{tenantId}/secondary-calendars/disconnect
   * @secure
   */
  disconnectSecondaryCalendarFromGoogle = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      user_id: string;
      /** @minLength 1 */
      account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DisconnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/secondary-calendars/disconnect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnectSecondaryCalendarFromGoogle */
  disconnectSecondaryCalendarFromGooglePathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      user_id: string;
      /** @minLength 1 */
      account_id: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/secondary-calendars/disconnect`, query);

  /**
   * @description Requests connection status of a given credential ref
   *
   * @name GetConnectionStatusOfAnAccount
   * @request GET:/v2/tenant/{tenantId}/credential-ref/{credentialRef}/status
   * @secure
   */
  getConnectionStatusOfAnAccount = (tenantId: string, credentialRef: string, params: RequestParams = {}) =>
    this.request<
      IntegrationStatusResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/credential-ref/${credentialRef}/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getConnectionStatusOfAnAccount */
  getConnectionStatusOfAnAccountPathGetter = (tenantId: string, credentialRef: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/credential-ref/${credentialRef}/status`);

  /**
   * @description Requests connection status of accounts of a given tenant (excl. tenant-wide accounts)
   *
   * @name GetConnectionStatusForUsersOfATenant
   * @request POST:/v2/tenant/{tenantId}/account/status
   * @secure
   */
  getConnectionStatusForUsersOfATenant = (
    tenantId: string,
    data: IntegrationStatusListRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      IntegrationStatusListResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/account/status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getConnectionStatusForUsersOfATenant */
  getConnectionStatusForUsersOfATenantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/account/status`);
}
